import { EventsItem } from "@/types";
import dayjs, { Dayjs } from "dayjs";
import { uuid } from "@/utils/string.ts";
import EventItem from "@/components/agenda/mobile/EventItem.tsx";

type Props = {
  events?: EventsItem[];
  date: Dayjs;
};
const Slot: React.FC<Props> = (props) => {
  // const { events, date, link_meet, link_video, ...rest } = props;
  const { events, date, ...rest } = props;

  return (
    <div
      {...rest}
      className={
        "py-3 grid-cols-[30px_auto] px-2 grid gap-4 rounded-md data-[todaytarget=true]:bg-[#9984D4] data-[todaytarget=true]:bg-opacity-1 custom-scroll-bug-fix"
      }
    >
      <div
        className={
          "flex flex-col text-white ${s.gridItemColor} data-[todaytarget]:text-[--primary] "
        }
      >
        <p className="uppercase text-[13px] leading-[100.5%] font-[500] text-center">
          {date.format("ddd")}
        </p>
        <p className="text-base font-[700] text-center">{date.format("DD")}</p>
      </div>
      <div className="w-full h-full grid grid-cols-1 gap-[5px]">
        {events && events.length > 0 ? (
          events?.map((event) => {
            const startDate = dayjs
              .tz(event.data + " " + event.ora, "Europe/Rome")
              .local();
            const endTime =
              event.ora_fine == null
                ? dayjs
                    .tz(event.data + " " + event.ora, "Europe/Rome")
                    .add(1, "hour")
                    .local()
                : dayjs
                    .tz(event.data + " " + event.ora_fine, "Europe/Rome")
                    .local();
            const duration = endTime.diff(startDate, "minutes");
            const isPast = dayjs().isAfter(endTime, "minutes");

            const isPresent = event.user_events[0]?.is_logged_in;

            return (
              <EventItem
                key={uuid()}
                event={event}
                endTime={endTime}
                date={startDate}
                isPast={isPast}
                isPresent={isPresent}
                duration={duration}
                startDate={startDate}
              />
            );
          })
        ) : (
          <div className="w-full border-brand-auth border-solid border-[1px] rounded-md flex flex-row  items-center pl-4 text-brand-auth text-xs">
            No event planned
          </div>
        )}
      </div>
    </div>
  );
};
export default Slot;
